import * as React from "react"
import styled from "styled-components"
import WhyUsSection from "./WhyUsSection";
import WhoAreWeSection from "./WhoAreWe";
import HelpYouSection from "./HelpYouSection";
import useTranslation from "../../shared/utils/translation";
import TitlePrimary from "../../shared/components/text/TitlePrimary";
import DividerLine from "../../shared/components/DividerLine";
import {sectionMargin} from "../../shared/utils/vars";
import ImageGrid from "../../shared/components/grid/ImageGrid";
import useWindowDimensions from "../../shared/utils/windowSize";
import {sizes} from "../../shared/utils/media";
import FooterSection from "./FooterSection";

const Wrapper = styled.div`
  overflow: hidden;
  margin-top: 48px;
`
const TitleWrapper = styled.div`
  text-align: center;
  margin: ${sectionMargin}
`

const HomeWrapper = () => {
  const t = useTranslation()
  const {width} = useWindowDimensions()

  const imageCollage = [
    {src: "/static/images/adapter.png"},
    {src: "/static/images/powersupply.png"},
  ]

  return (
    <Wrapper>
      <TitleWrapper>
        <TitlePrimary small={width < sizes.tablet}>{t("common.title.home")}</TitlePrimary>
      </TitleWrapper>
      <ImageGrid object={[{src: "static/images/red-banner.jpg"}]} imageStyle={{maxWidth: "100%", height: "100"}}/>
      <DividerLine/>
      <WhyUsSection/>
      <DividerLine/>
      <ImageGrid object={imageCollage} imageStyle={{maxWidth: "100%", height: "360px"}}/>
      <DividerLine/>
      <WhoAreWeSection/>
      <DividerLine/>
      <HelpYouSection/>
      {width > sizes.tablet && (
        <>
          <DividerLine/>
          <FooterSection/>
        </>
      )}
    </Wrapper>
  )
}

export default HomeWrapper
